/* ==========================================================================
   divano — zachowania interfejsu
   Animacje i interakcje odwzorowane z projektu Claude Design.
   ========================================================================== */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var routes = (window.divanoRoutes = window.divanoRoutes || {});
  var strings = (window.divanoStrings = window.divanoStrings || {});

  /* ---------------------------------------------------------- narzędzia -- */

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function on(el, evt, sel, fn) {
    el.addEventListener(evt, function (e) {
      var target = e.target.closest(sel);
      if (target && el.contains(target)) fn.call(target, e, target);
    });
  }

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function fetchJSON(url, options) {
    return fetch(url, options).then(function (r) {
      if (!r.ok) return r.json().then(function (body) { throw body; });
      return r.json();
    });
  }

  /* ------------------------------------------------- odsłanianie sekcji -- */

  var revealObserver = null;

  function initReveal(scope) {
    var targets = $$('[data-reveal]', scope || document).filter(function (el) {
      return !el.dataset.revealArmed;
    });
    if (!targets.length) return;

    if (reduceMotion) {
      targets.forEach(function (el) { el.dataset.revealArmed = '1'; el.classList.add('no-reveal'); });
      return;
    }

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    }

    targets.forEach(function (el, i) {
      el.dataset.revealArmed = '1';
      // Elementy widoczne od razu po wejściu na stronę pokazujemy bez animacji,
      // żeby pierwszy ekran nie migał.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) {
        el.classList.add('no-reveal');
        return;
      }
      var delay = (i % 4) * 0.07;
      el.style.transitionDelay = delay + 's, ' + delay + 's';
      revealObserver.observe(el);
    });
  }

  /* ------------------------------------------------------- menu mobilne -- */

  function initMenu() {
    var burger = $('[data-menu-toggle]');
    var menu = $('[data-menu]');
    if (!burger || !menu) return;

    burger.addEventListener('click', function () {
      var open = burger.getAttribute('aria-expanded') === 'true';
      setMenu(!open);
    });

    on(menu, 'click', 'a', function () { setMenu(false); });

    function setMenu(open) {
      burger.setAttribute('aria-expanded', String(open));
      menu.style.maxHeight = open ? menu.scrollHeight + 'px' : '0px';
      menu.style.opacity = open ? '1' : '0';
    }

    window.addEventListener('resize', debounce(function () {
      if (burger.getAttribute('aria-expanded') === 'true') {
        menu.style.maxHeight = menu.scrollHeight + 'px';
      }
    }, 150));
  }

  /* ----------------------------------------------------------- akordeon -- */

  function initAccordions(scope) {
    $$('[data-accordion-toggle]', scope || document).forEach(function (btn) {
      if (btn.dataset.accArmed) return;
      btn.dataset.accArmed = '1';

      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;

      if (btn.getAttribute('aria-expanded') === 'true') openPanel(panel);

      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (open) closePanel(panel); else openPanel(panel);
      });
    });

    function openPanel(panel) {
      panel.dataset.open = 'true';
      panel.style.maxHeight = panel.scrollHeight + 'px';
      // Po zakończeniu animacji zdejmujemy limit, żeby treść mogła rosnąć.
      setTimeout(function () {
        if (panel.dataset.open === 'true') panel.style.maxHeight = 'none';
      }, 460);
    }

    function closePanel(panel) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        panel.dataset.open = 'false';
        panel.style.maxHeight = '0px';
      });
    }
  }

  /* ------------------------------------------------------------- filtry -- */

  function initFacets() {
    var toggle = $('[data-facets-toggle]');
    var panel = $('[data-facets]');
    if (!toggle || !panel) return;

    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.style.maxHeight = open ? '0px' : panel.scrollHeight + 'px';
      panel.style.opacity = open ? '0' : '1';
      var label = toggle.querySelector('[data-facets-label]');
      if (label) label.textContent = open ? label.dataset.closed : label.dataset.open;
    });

    // Auto-submit formularza filtrów.
    var form = $('[data-facets-form]');
    if (form) {
      form.addEventListener('change', function () { form.submit(); });
    }

    var sort = $('[data-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    }
  }

  /* -------------------------------------------------------------- toast -- */

  var toastTimer;

  function toast(message) {
    var el = $('[data-toast]');
    if (!el) return;
    $('[data-toast-text]', el).textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }

  /* ----------------------------------------------------- szuflada koszyka -- */

  var CartDrawer = {
    el: null,
    scrim: null,
    lastFocus: null,

    init: function () {
      this.el = $('[data-cart-drawer]');
      this.scrim = $('[data-cart-scrim]');
      if (!this.el) return;

      var self = this;

      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) {
          e.preventDefault();
          self.open();
        } else if (e.target.closest('[data-cart-close]')) {
          e.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close();
      });

      this.el.addEventListener('keydown', function (e) {
        if (e.key !== 'Tab') return;
        var focusable = $$('a[href], button:not([disabled]), input, select, textarea', self.el)
          .filter(function (n) { return n.offsetParent !== null; });
        if (!focusable.length) return;
        var first = focusable[0], last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    },

    open: function () {
      if (!this.el) return;
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      if (this.scrim) this.scrim.classList.add('is-open');
      document.body.classList.add('is-locked');
      var close = $('[data-cart-close]', this.el);
      if (close) setTimeout(function () { close.focus(); }, 60);
    },

    close: function () {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      if (this.scrim) this.scrim.classList.remove('is-open');
      document.body.classList.remove('is-locked');
      if (this.lastFocus) this.lastFocus.focus();
    },

    busy: function (state) {
      if (this.el) this.el.classList.toggle('is-busy', !!state);
    },

    refresh: function () {
      var self = this;
      return fetch(routes.root + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
          var fresh = $('[data-cart-drawer-content]', html);
          var current = $('[data-cart-drawer-content]');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          initAccordions(current);
          return fetchJSON(routes.cart + '.js');
        })
        .then(function (cart) {
          self.updateCount(cart.item_count);
          return cart;
        });
    },

    updateCount: function (count) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
      $$('[data-cart-count-wrapper]').forEach(function (el) {
        el.classList.toggle('is-empty', count === 0);
      });
    }
  };

  /* ------------------------------------------------- operacje na koszyku -- */

  function cartAdd(formData, button) {
    if (button) button.classList.add('is-loading');
    formData.append('sections', 'cart-drawer');

    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { Accept: 'application/javascript' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          toast(data.description || data.message);
          return null;
        }
        return CartDrawer.refresh().then(function () {
          CartDrawer.open();
          return data;
        });
      })
      .catch(function () { toast(strings.error || 'Coś poszło nie tak. Spróbuj ponownie.'); })
      .finally(function () { if (button) button.classList.remove('is-loading'); });
  }

  function cartChange(payload) {
    CartDrawer.busy(true);
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Strona koszyka przeładowuje się, żeby przeliczyć rabaty i wysyłkę.
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return cart;
        }
        return CartDrawer.refresh();
      })
      .catch(function () { toast(strings.error || 'Coś poszło nie tak. Spróbuj ponownie.'); })
      .finally(function () { CartDrawer.busy(false); });
  }

  function initCartActions() {
    document.addEventListener('click', function (e) {
      var minus = e.target.closest('[data-qty-minus]');
      var plus = e.target.closest('[data-qty-plus]');
      var remove = e.target.closest('[data-cart-remove]');

      if (minus || plus) {
        var wrap = (minus || plus).closest('[data-qty]');
        var input = $('input', wrap);
        if (!input) return;
        var min = parseInt(input.min || '1', 10);
        var max = input.max ? parseInt(input.max, 10) : Infinity;
        var next = parseInt(input.value || '1', 10) + (plus ? 1 : -1);
        next = Math.max(min, Math.min(max, next));
        if (String(next) === input.value) return;
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (remove) {
        e.preventDefault();
        cartChange({ line: parseInt(remove.dataset.cartRemove, 10), quantity: 0 });
      }
    });

    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-qty]');
      if (!input) return;
      cartChange({ line: parseInt(input.dataset.line, 10), quantity: parseInt(input.value, 10) });
    });

    // Formularze dodania do koszyka (karta produktu i szybkie dodanie z siatki).
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      cartAdd(new FormData(form), $('[type="submit"]', form));
    });
  }

  /* --------------------------------------------------------- wariantowanie -- */

  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var section = picker.closest('[data-product-section]');
      if (!section) return;

      var data = JSON.parse($('[data-variant-json]', section).textContent);
      var idInput = $('[data-variant-id]', section);
      var priceEl = $('[data-price]', section);
      var submitEl = $('[data-add-button]', section);
      var labelEl = $('[data-add-label]', section);
      var stockEl = $('[data-stock-note]', section);
      var skuEl = $('[data-sku]', section);

      picker.addEventListener('change', function () { update(); });
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('label');
        if (btn) setTimeout(update, 0);
      });

      function selectedOptions() {
        return $$('input:checked', picker).map(function (i) { return i.value; });
      }

      function update() {
        var chosen = selectedOptions();

        // Podpis przy nazwie opcji.
        $$('[data-option-value]', section).forEach(function (el) {
          var idx = parseInt(el.dataset.optionValue, 10);
          if (chosen[idx]) el.textContent = chosen[idx];
        });

        var variant = data.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });

        if (!variant) {
          if (submitEl) { submitEl.disabled = true; submitEl.classList.add('btn--disabled'); }
          if (labelEl) labelEl.textContent = strings.unavailable || 'Wariant niedostępny';
          if (stockEl) stockEl.textContent = '';
          return;
        }

        if (idInput) idInput.value = variant.id;

        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());

        if (priceEl && variant.price_html) priceEl.innerHTML = variant.price_html;
        if (skuEl) skuEl.textContent = variant.sku || '';

        if (submitEl) {
          submitEl.disabled = !variant.available;
          submitEl.classList.toggle('btn--disabled', !variant.available);
        }
        if (labelEl) {
          labelEl.textContent = variant.available
            ? (strings.addToCart || 'Dodaj do koszyka') + ' · ' + variant.price_label
            : (strings.soldOut || 'Wyprzedane');
        }
        if (stockEl) stockEl.textContent = variant.stock_note || '';

        // Przewinięcie galerii do zdjęcia wariantu.
        if (variant.image_id) {
          var img = $('[data-media-id="' + variant.image_id + '"]', section);
          if (img) img.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
        }
      }

      update();
    });
  }

  /* ------------------------------------------------- powiększenie zdjęcia -- */

  function initLightbox() {
    var box = $('[data-lightbox]');
    if (!box) return;
    var img = $('img', box);

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox-open]');
      if (trigger) {
        img.src = trigger.dataset.lightboxOpen || trigger.src;
        img.alt = trigger.alt || '';
        box.classList.add('is-open');
        document.body.classList.add('is-locked');
        $('[data-lightbox-close]', box).focus();
        return;
      }
      if (e.target.closest('[data-lightbox-close]') || e.target === box) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });

    function close() {
      box.classList.remove('is-open');
      document.body.classList.remove('is-locked');
    }
  }

  /* --------------------------------------------------- wyszukiwarka live -- */

  function initSearch() {
    var toggle = $('[data-search-open]');
    var panel = $('[data-search-panel]');
    if (!toggle || !panel) return;

    var input = $('input[type="search"]', panel);
    var results = $('[data-search-results]', panel);

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      panel.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(panel.classList.contains('is-open')));
      if (panel.classList.contains('is-open')) setTimeout(function () { input.focus(); }, 60);
    });

    document.addEventListener('click', function (e) {
      if (!panel.contains(e.target) && !toggle.contains(e.target)) {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        panel.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });

    if (!input || !results) return;

    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }

      fetch(
        routes.predictive +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,page,article&resources[limit]=6&section_id=predictive-search'
      )
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-predictive-results]', doc);
          results.innerHTML = fresh ? fresh.innerHTML : '';
        })
        .catch(function () { results.innerHTML = ''; });
    }, 240));
  }

  /* -------------------------------------------------- lokalizacja/waluta -- */

  function initLocalization() {
    $$('[data-localization-form] select').forEach(function (select) {
      select.addEventListener('change', function () {
        select.closest('form').submit();
      });
    });
  }

  /* ------------------------------------------------------ formularz kodu -- */

  function initNewsletterFeedback() {
    $$('[data-newsletter]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var btn = $('[type="submit"]', form);
        if (btn) btn.classList.add('is-loading');
      });
    });
  }

  /* -------------------------------------------------------------- start -- */

  function boot() {
    initReveal();
    initMenu();
    initAccordions();
    initFacets();
    initCartActions();
    initVariantPickers();
    initLightbox();
    initSearch();
    initLocalization();
    initNewsletterFeedback();
    CartDrawer.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Theme editor — sekcje wczytywane po załadowaniu strony.
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    initAccordions(e.target);
    initVariantPickers();
    CartDrawer.init();
  });

  window.divano = {
    toast: toast,
    cartAdd: cartAdd,
    cartChange: cartChange,
    drawer: CartDrawer,
    initReveal: initReveal
  };
})();
